import http, {reqDefaultConfig} from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  select: '/base/category/select',
  area: '/base/area',
};

/**
 * 获取首页分类
 * @param query
 * @param reqConfig
 * @returns {{result: {}, getCategory: (...params: any[]) => Promise<unknown>, loading: boolean, error: Error}}
 */
export const useCategorySelect = (query, reqConfig) => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.select,
      method: 'get',
      data: query || q || {}
    },{noAgent:true});
  }, { ...reqConfig, ...reqDefaultConfig });
  
  const getCategorysTree = (body) => {
    if (!body) return;
    
    let arr = body.data || [];
    let temp = {};
    let tree = {};
    // 数组转 键值对
    arr.forEach((item) => {
      temp[item.categoryId] = item;
    });
    
    let tempKeys = Object.keys(temp);
    tempKeys.forEach((key) => {
      // 获取当前项
      let item = temp[key];
      // 当前项
      let _itemPId = item.parentId;
      // 获取父级项
      let parentItemByPid = temp[_itemPId];
      if (parentItemByPid) {
        if (!parentItemByPid.children) {
          parentItemByPid.children = [];
        }
        parentItemByPid.children.push(item);
      } else {
        tree[item.categoryId] = item;
      }
    });
    
    // 对象转数组并返回
    body.data = Object.keys(tree).map((key) => tree[key]);
    return body;
  };
  
  return {
    result: getCategorysTree(data) || {},
    loading,
    error,
    getCategory: runAsync,
  };
};

export const useBaseArea = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    return http({
      url: apiPath.area,
      method: 'get',
      data: q || {}
    });
  }, { manual: true, ...reqDefaultConfig });
  
  return {
    loading,
    getArea: runAsync
  };
};
